import { Button, Tooltip } from '@mui/material';

type ToolTipSpannerProps = {
  title: string;
  disabled: boolean;
  buttonVariant: 'text' | 'outlined' | 'contained';
  dataTestId: string;
  buttonLabel: string;
  onClick?: () => void;
};

export default function ToolTipSpanner({
  title,
  disabled,
  buttonVariant,
  dataTestId,
  buttonLabel,
  onClick,
}: ToolTipSpannerProps) {
  return (
    <Tooltip title={disabled ? title : ''}>
      <span>
        <Button
          variant={buttonVariant}
          disabled={disabled}
          data-testid={dataTestId}
          onClick={onClick}
        >
          {buttonLabel}
        </Button>
      </span>
    </Tooltip>
  );
}
